// extracted by mini-css-extract-plugin
module.exports = {"header":"PageHeader_header__2WdfC"};